export const fr = {
  app: { name: 'Câblerie — Gestion', short: 'Câblerie', tagline: 'Gestion de production' },
  errors: {
    title: 'Oups, un problème est survenu',
    body: 'La page a rencontré une erreur. Rechargez pour continuer ; les données déjà enregistrées ne sont pas perdues.',
    reload: 'Recharger la page',
    notFoundTitle: 'Page introuvable',
    notFoundBody: 'Cette adresse n’existe pas (ou plus). Revenez à l’accueil.',
    home: 'Retour à l’accueil',
  },
  prod: {
    client: {
      forName: 'Pour {{name}}',
      title: 'Client',
      all: 'Tous les clients',
      filter: 'Filtrer par client',
      stock: 'Pour le stock',
      workshop: 'OF atelier (stock)',
      for: 'Pour la commande du client',
      forHint: 'Ses bobines lui seront réservées. Vide = pour le stock.',
      card: 'Pour le client',
      ordered: 'Commandé : {{kg}}',
      wanted: 'souhaitée le {{date}}',
      attach: 'Rattacher à une commande',
      change: 'Changer de commande',
      detach: 'Détacher (pour le stock)',
      attachTitle: 'Rattacher {{code}} à une commande client',
      attachHint:
        'Les bobines faites à partir de maintenant à la dernière étape seront réservées à cette commande. Les commandes listées : même diamètre, pas encore en production.',
      none: 'Aucune commande de ce diamètre n’attend de production.',
      detachConfirm: 'Détacher cet OF de la commande ? Les bobines déjà réservées le restent.',
      forClient: 'Pour {{name}} · {{code}}',
    },
    grossTare: 'brut {{gross}} − tare {{tare}}',
    cycle: 'Cycle de l’OF',
    stepNext: 'Étape suivante',
    stepTotals_one: 'Entré {{in}} → sorti {{out}} · rebut {{scrap}} · {{count}} saisie',
    stepTotals_other: 'Entré {{in}} → sorti {{out}} · rebut {{scrap}} · {{count}} saisies',
    correctWeight: 'Corriger la pesée',
    correctTitle: 'Corriger la pesée — {{code}}',
    correctNow: 'Poids enregistré : {{net}}.',
    correctNowContainer: 'Enregistré : {{container}} brut {{gross}} − tare {{tare}} = {{net}} net.',
    newGross: 'Bon poids brut (kg)',
    newNet: 'Bon poids net (kg)',
    newNetIs: 'Nouveau net : {{net}}',
    correctReason: 'Motif (ex. erreur de lecture de la balance)',
    correctAudit:
      'La correction est enregistrée dans le stock (ajustement avec ce motif) et dans le journal d’audit. Possible tant que rien n’a été pris dans le lot.',
    stockOnlyHint:
      'Choisissez le produit (son diamètre) et le poids à fabriquer : l’étape de fin et la ligne se remplissent toutes seules.',
    moreOptions: 'Plus d’options (priorité, dates, notes)',
    lessOptions: 'Moins d’options',
    next: {
      draft:
        'Brouillon : vérifiez l’objectif, puis « Lancer » pour que l’OF apparaisse sur la tablette de l’atelier.',
      released:
        'Lancé : l’atelier choisit cet OF dans « Production » sur la tablette et saisit chaque étape. Le bilan cuivre apparaît ici dès la première saisie.',
      cancelled: 'OF annulé, sans production.',
    },
    woKind: 'Type d’OF',
    kindFinished: 'Produit fini (article et unités)',
    kindStock: 'Pour le stock (en-cours jusqu’à une étape)',
    forStock: 'Pour le stock',
    until: 'jusqu’à {{stage}}',
    endStage: 'Étape de fin',
    targetKg: 'Objectif (kg)',
    workOrders: 'Ordres de fabrication',
    newWo: 'Nouvel OF',
    noSku:
      'Aucun article à produire. Un article = un produit dans un conditionnement : créez d’abord le conditionnement (ex. Couronne 100 m), puis l’article.',
    trace: 'Traçabilité',
    filters: { open: 'En cours / lancés', draft: 'Brouillons', done: 'Terminés', all: 'Tous' },
    code: 'OF',
    product: 'Produit',
    sku: 'Article',
    line: 'Ligne',
    target: 'Objectif',
    produced: 'Produit',
    targetUnits: 'Unités à produire',
    targetLengthM: 'Longueur totale (m)',
    targetLengthHint: 'Obligatoire pour un article à la coupe',
    plannedStart: 'Début prévu',
    plannedEnd: 'Fin prévue',
    priority: 'Priorité (0–9)',
    notes: 'Notes',
    status: 'Statut',
    currentStage: 'Étape en cours',
    actions: {
      release: 'Lancer',
      unrelease: 'Remettre en brouillon',
      complete: 'Terminer',
      cancel: 'Annuler l’OF',
      edit: 'Modifier',
      confirmComplete: 'Terminer cet OF ? Les lots en-cours restants resteront en stock.',
      confirmCancel: 'Annuler cet OF ?',
    },
    routing: 'Gamme',
    stageLogs: 'Journal des étapes',
    wipLots: 'Lots en-cours',
    finishedUnits: 'Unités produites',
    printSelected: 'Imprimer les étiquettes',
    copper: 'Bilan cuivre de l’OF',
    copperIn: 'Cuivre entré',
    copperFg: 'Produits finis (théorique)',
    copperScrap: 'Rebuts (cuivre)',
    copperWip: 'Variation en-cours',
    copperSold: 'Vendu en cours',
    variance: 'Écart',
    flagged: 'Écart au-delà du seuil',
    operatorCol: 'Opérateur',
    machine: 'Machine',
    inputs: 'Entrées',
    output: 'Sortie',
    scrap: 'Rebut',
    date: 'Date',
    remaining: 'Reste',
    qc: 'CQ',
    stock: 'Stock',
    lengthM: 'Longueur',
    netKg: 'Poids net',
    none: 'Aucun',
    traceIntro: 'Scannez ou saisissez un code de lot ou un n° de série.',
    backward: 'Origine (amont)',
    forward: 'Destination (aval)',
    search: 'Rechercher',
    truncated: '… {{count}} autres',
    repeated: 'déjà affiché',
    wipStatus: {
      AVAILABLE: 'Disponible',
      CONSUMED: 'Consommé',
      ON_HOLD: 'Bloqué',
      SCRAPPED: 'Rebuté',
    },
  },
  qcStatus: { PENDING: 'En attente', PASS: 'Conforme', FAIL: 'Non conforme' },
  situation: {
    title: 'Situation des clients',
    intro:
      'Qui a payé et qui doit : factures validées, règlements et avoirs, reste dû et retards. Cliquez un client pour son relevé.',
    owed: 'Reste dû',
    ofInvoiced: 'sur {{amount}} facturés',
    late: 'Dont en retard',
    customersCount_one: '{{count}} client en retard',
    customersCount_other: '{{count}} clients en retard',
    debtHint: 'doivent, sans retard',
    noInvoice_one: '{{count}} sans facture',
    noInvoice_other: '{{count}} sans facture',
    filter: 'Situation',
    all: 'Tous',
    search: 'Client, code ou ville…',
    empty: 'Aucun client pour ce filtre.',
    situation: 'Situation',
    invoiced: 'Facturé TTC',
    settled: 'Réglé',
    balance: 'Reste dû',
    overdue: 'En retard',
    openInvoices: 'Factures ouvertes',
    lastPayment: 'Dernier règlement',
    daysLate_one: '{{count}} jour de retard',
    daysLate_other: '{{count}} jours de retard',
    overLimit: 'au-delà du plafond ({{limit}})',
    status: { NONE: 'Aucune facture', PAID: 'À jour', DEBT: 'En dette', OVERDUE: 'En retard' },
  },
  sales: {
    inv: {
      issued: 'émise le {{date}}',
      due: 'échéance le {{date}}',
      printPdf: 'Imprimer / PDF',
      recordPayment: 'Enregistrer un paiement',
      docTitle: 'FACTURE',
      draftTitle: 'FACTURE (BROUILLON)',
      date: 'Date',
      dueLabel: 'Échéance',
      order: 'Commande',
      dn: 'Bon de livraison',
      billedTo: 'FACTURÉ À',
      designation: 'Désignation',
      customerMissing:
        'Client {{name}} : il manque {{list}} — obligatoire pour valider la facture.',
      completeCustomer: 'Compléter la fiche client',
      addressWord: 'adresse',
      draftHint:
        'Brouillon : vous pouvez encore changer le prix unitaire et la TVA de chaque ligne (le prix bouge), puis Enregistrer. Après validation, la facture ne change plus (avoir).',
      diameter: 'Diamètre',
      qty: 'Quantité',
      priceHt: 'Prix HT',
      amountHt: 'Montant HT',
      totalWeight: 'Poids total livré',
      vatLine: 'TVA {{rate}} %',
      stamp: 'Droit de timbre',
      stampNone: 'aucun règlement en espèces',
      netToPay: 'Net à payer TTC',
      payBy: 'Règlement : {{method}}',
      validatedOn: 'Validée le {{date}} · ne peut plus être modifiée',
      draftNote: 'Brouillon : modifiable jusqu’à sa validation',
      payments: 'Paiements',
      add: 'Ajouter',
      remaining: 'Reste à payer',
      dueIn: 'échéance dans {{days}} jours',
      dueToday: 'échéance aujourd’hui',
      lateBy: 'en retard de {{days}} jours',
      paidPct: 'Payé {{paid}} · {{pct}} %',
      of: 'sur {{total}}',
      noPayment: 'Aucun paiement enregistré',
      linked: 'Documents liés',
      orderDoc: 'Commande · {{date}}',
      dnDoc_one: 'Bon de livraison · {{date}} · {{count}} lot',
      dnDoc_other: 'Bon de livraison · {{date}} · {{count}} lots',
      creditNotes: 'Avoirs',
      noCredit: 'Aucun avoir',
      noCreditHint:
        'Une facture validée ne se supprime pas. Pour la corriger, « Annuler la facture » émet un avoir et peut remettre le fil en stock.',
      partialCredit: 'Avoir partiel ou retour client',
      history: 'Historique',
      hDraft: 'Brouillon créé',
      hDraftFrom: 'Brouillon créé depuis {{dn}}',
      hValidated: 'Facture validée',
      hPayment: 'Paiement enregistré : {{method}}',
      hCredit: 'Avoir {{number}}',
    },
    rev: {
      title: 'Annuler la facture {{number}}',
      sub: '{{customer}} · {{ttc}} TTC',
      intro:
        'La facture n’est pas supprimée. Un avoir est émis pour tout ce qui n’est pas encore crédité, et il solde la facture.',
      total: 'Avoir total',
      partial: 'Avoir partiel',
      what: 'Que devient le fil livré ?',
      stock: 'Retour en stock dans ses lots',
      stockHint: 'Les {{kg}} reviennent dans leurs lots ({{dn}}), après une pesée de contrôle.',
      scrap: 'Retour au déchet',
      scrapHint: 'Le fil repart à la fonte comme déchet de cuivre.',
      none: 'Pas de retour de fil',
      noneHint: 'Avoir financier seulement, par exemple pour une erreur de prix.',
      paid: '{{paid}} déjà payés restent au crédit du client, ou peuvent être remboursés depuis « Situation client ».',
      reason: 'Motif (obligatoire)',
      reasonPh: 'Ex. : erreur de diamètre sur la ligne 2',
      back: 'Retour',
      confirm: 'Émettre l’avoir et annuler',
    },
    returnWire: 'Fil retourné par le client',
    returnWireHint:
      'Pesez ce qui revient, bobine par bobine : il revient au stock fini, ou au déchet s’il est à refondre. Le poids crédité suit (modifiable).',
    wireReturned: 'Revenu en stock (ou au déchet) à la validation de l’avoir.',
    returnTo: 'Destination',
    toStock: 'Retour au stock fini',
    toScrap: 'Au déchet (à refondre)',
    wireLeft: 'encore chez le client : {{kg}}',
    returnKg: 'Poids retourné',
    reverse: 'Annuler la facture',
    reverseConfirm: 'Annuler par un avoir',
    reverseIntro:
      'Une facture validée ne se supprime pas (numérotation légale). L’annulation crée un avoir pour tout ce qui n’a pas encore été crédité, validé tout de suite : la facture est soldée.',
    reverseReturn: 'La marchandise livrée revient en stock (le client la rend)',
    byWeight: 'Au poids (fil nu par diamètre)',
    deleteDraft: 'Supprimer le brouillon',
    confirmDeleteDraft: 'Supprimer définitivement ce brouillon ? (il n’a pas encore de numéro)',
    lockedInvoice:
      'Facture validée : elle ne se supprime pas — pour l’annuler, établissez un avoir.',
    lockedDn: 'Bon validé : il ne se supprime pas — un retour passe par un avoir sur la facture.',
    orderBy: 'Commandé',
    byUnits: 'en unités',
    byKg: 'au poids (kg)',
    productOptional: 'Produit (facultatif)',
    anyProduct: '— Tout produit (étape + diamètre) —',
    cut: 'à la coupe',
    nav: {
      overview: 'Vue d’ensemble',
      orders: 'Commandes',
      deliveries: 'Bons de livraison',
      invoices: 'Factures',
      creditNotes: 'Avoirs',
      proformas: 'Proformas',
      customers: 'Clients',
      receivables: 'Créances',
      situation: 'Situation clients',
    },
    orderStatus: {
      DRAFT: 'Brouillon',
      CONFIRMED: 'Confirmée',
      PARTIALLY_DELIVERED: 'Livrée partiellement',
      DELIVERED: 'Livrée',
      CANCELLED: 'Annulée',
    },
    docStatus: { DRAFT: 'Brouillon', VALIDATED: 'Validé', CANCELLED: 'Annulé' },
    payStatus: { UNPAID: 'Impayée', PARTIAL: 'Partiellement réglée', PAID: 'Réglée' },
    priceUnit: { PER_METER: 'DA / m', PER_UNIT: 'DA / unité', PER_KG: 'DA / kg' },
    newOrder: 'Nouvelle commande',
    order: 'Commande',
    customer: 'Client',
    date: 'Date',
    number: 'N°',
    lines: 'Lignes',
    addLine: 'Ajouter une ligne',
    kind: 'Type de vente',
    sku: 'Article',
    cutSku: 'Article à la coupe',
    product: 'Produit',
    stage: 'Étape',
    diameter: 'Diamètre (mm)',
    units: 'Unités',
    pieces: 'Pièces',
    cutLength: 'Longueur par pièce (m)',
    qtyKg: 'Quantité (kg)',
    qtyM: 'Quantité (m)',
    priceUnitLabel: 'Prix par',
    unitPrice: 'Prix HT',
    vat: 'TVA %',
    paymentMethod: 'Mode de paiement',
    requestedDate: 'Livraison souhaitée',
    notes: 'Notes',
    confirm: 'Confirmer la commande',
    cancelOrder: 'Annuler la commande',
    confirmCancel: 'Annuler cette commande ? Les réservations seront libérées.',
    reserve: 'Réserver',
    autoReserve: 'Réserver automatiquement',
    reserved: 'Réservé',
    delivered: 'Livré',
    release: 'Libérer',
    candidates: 'Stock disponible',
    noCandidates: 'Aucun stock correspondant.',
    reserveKg: 'kg à réserver',
    deliver: 'Préparer une livraison',
    newDelivery: 'Nouveau bon de livraison',
    vehicle: 'Véhicule',
    driver: 'Chauffeur',
    address: 'Adresse de livraison',
    customerAddress: 'Adresse (imprimée sur les factures)',
    items: 'Lots',
    validate: 'Valider',
    validateDn: 'Valider la livraison (sortie de stock)',
    billDn: 'Facturer cette livraison',
    pdf: 'PDF',
    invoice: 'Facture',
    newInvoice: 'Facturer des livraisons',
    uninvoiced: 'Livraisons non facturées',
    createInvoice: 'Créer la facture (brouillon)',
    validateInvoice: 'Valider la facture (numéro définitif)',
    confirmValidate:
      'Valider ? La facture reçoit un numéro définitif et ne pourra plus être modifiée (corrections par avoir).',
    cancelDraft: 'Abandonner le brouillon',
    totalHt: 'Total HT',
    totalVat: 'TVA',
    totalTtc: 'Total TTC',
    stamp: 'Droit de timbre',
    netToPay: 'Net à payer',
    paid: 'Réglé',
    remaining: 'Reste à payer',
    dueDate: 'Échéance',
    inWords: 'Arrêtée la présente facture à la somme de',
    payments: 'Règlements',
    addPayment: 'Enregistrer un règlement',
    amount: 'Montant',
    reference: 'Référence (n° chèque, virement…)',
    bank: 'Banque',
    creditNote: 'Avoir',
    newCreditNote: 'Créer un avoir',
    reason: 'Motif',
    creditQty: 'Qté à créditer',
    returnUnits: 'Unités retournées en stock',
    returnUnitsHint:
      'Cochez les unités que le client renvoie : la quantité à créditer se remplit, et elles reviennent en stock à la validation de l’avoir, en attente de contrôle qualité.',
    onCreditNote: 'déjà sur l’avoir {{number}}',
    backInStock: 'déjà revenue en stock',
    returnOnValidate: 'Ces unités reviendront en stock à la validation de l’avoir.',
    returnedQc:
      'Revenues en stock, en attente de contrôle qualité : elles ne seront livrables qu’après un contrôle conforme.',
    validateCreditNote: 'Valider l’avoir',
    proforma: 'Proforma',
    newProforma: 'Nouvelle proforma',
    description: 'Désignation',
    qty: 'Quantité',
    validUntil: 'Valable jusqu’au',
    receivables: 'Créances clients',
    aging: {
      notDue: 'Non échu',
      d30: '1–30 j',
      d60: '31–60 j',
      d90: '61–90 j',
      over90: '> 90 j',
      total: 'Total',
    },
    overdue: 'Factures échues',
    daysLate: 'Retard (j)',
    statement: 'Relevé de compte',
    debit: 'Débit',
    credit: 'Crédit',
    balance: 'Solde',
    paymentTerms: 'Délai de paiement (j)',
    creditLimit: 'Plafond de crédit (DA)',
    code: 'Code',
    name: 'Raison sociale',
    codeHint: 'CLI-0001… si vide',
    available: 'Disponible',
    city: 'Ville',
    wilaya: 'Wilaya',
    phone: 'Téléphone',
    email: 'E-mail',
    contact: 'Contact',
    legalForm: 'Forme juridique',
    articleImposition: 'Article d’imposition',
    active: 'Actif',
    flowHint: 'D’où part la marchandise pour ce type de vente :',
    qcWarning: '{{count}} unité(s) sans contrôle qualité conforme : la validation sera refusée.',
    toOrder: 'Créer la commande',
    approvalPending:
      'Plafond de crédit dépassé ou impayés échus : approbation du propriétaire demandée le {{date}}. La commande sera confirmée dès son accord.',
    approvalRejected: 'Refusée par {{name}} le {{date}}.',
    fromProforma:
      'Depuis la proforma {{number}} — vérifiez les lignes signalées, puis enregistrez.',
    customerFromProforma: 'Client de la proforma',
    proformaExpired:
      'Proforma expirée le {{date}} : vérifiez que les prix sont toujours valables avant d’enregistrer.',
    proformaLine: 'Proforma : {{description}} — {{qty}} × {{price}} {{unit}}',
    proformaStatus: {
      DRAFT: 'Brouillon',
      ISSUED: 'Émise',
      ACCEPTED: 'Acceptée',
      EXPIRED: 'Expirée',
      CANCELLED: 'Annulée',
    },
    proformaIssue: {
      NO_SKU: 'Ligne libre sur la proforma : choisissez l’article vendu (ou supprimez la ligne).',
      PER_KG: 'Prix au kg sur la proforma : saisissez le prix au mètre ou à l’unité.',
      CUT_LENGTH_MISSING: 'Pièces à la coupe : indiquez la longueur de chaque pièce.',
      UNITS_MISSING: 'Conditionnement sans longueur nominale : indiquez le nombre d’unités.',
      ROUNDED_UP:
        'Arrondi au conditionnement entier supérieur : vérifiez la quantité avec le client.',
      FRACTIONAL_UNITS: 'Quantité arrondie à l’unité supérieure.',
      ONE_PIECE:
        'Une seule pièce de la longueur demandée : divisez-la si le client veut plusieurs pièces.',
    },
  },
  materialsMonthly: {
    title: 'Déchet et fil 3 mm — analyse mensuelle',
    intro:
      'Chaque mois : stock au début, ce qui est entré (acheté, fabriqué à la fusion, récupéré), ce qui est sorti (fondu, tréfilé), les écarts d’inventaire et le stock à la fin. Tout vient des mouvements de stock.',
    fromMonth: 'Du mois',
    toMonth: 'Au mois',
    previous: 'Mois précédent',
    next: 'Mois suivant',
    dechet: 'Déchet de cuivre',
    wire: 'Fil 3 mm',
    fusion: 'Fusion du mois',
    noFusion: 'Aucune fusion ce mois-ci.',
    opening: 'Stock au début du mois',
    closing: 'Stock à la fin du mois',
    bought: 'Acheté',
    recoveredFusion: 'Récupéré à la fusion',
    recoveredProduction: 'Rebut de production renvoyé',
    returned: 'Retour client',
    meltedOut: 'Fondu (fusion)',
    usedOther: 'Pris par une étape',
    made: 'Fabriqué à la fusion',
    drawnOut: 'Pris par le tréfilage',
    count: 'Écart d’inventaire',
    corrections: 'Corrections et sorties',
    baskets: 'Paniers',
    basketsN_one: '{{count}} panier',
    basketsN_other: '{{count}} paniers',
    melted: 'Déchet fondu',
    made3mm: 'Fil 3 mm obtenu',
    recovered: 'Récupéré (retour au déchet)',
    slag: 'Scories',
    gap: 'Écart non déclaré',
    yield: 'Rendement fusion',
    dechetEnd: 'Déchet en fin de mois',
    wireEnd: 'Fil 3 mm en fin de mois',
    drawn: '3 mm tréfilé dans le mois',
    byMonth: 'Mois par mois (kg)',
    month: 'Mois',
    colOpening: 'Début',
    colIn: 'Entrées',
    colOut: 'Sorties',
    colClosing: 'Fin',
  },
  reports: {
    copperTitle: 'Bilan matière cuivre',
    copperIntro:
      'Cuivre entré (déchet de cuivre consommé) = produits finis (poids théorique) + rebuts + variation des en-cours + ventes en cours + écart.',
    from: 'Du',
    to: 'Au',
    allLines: 'Toutes les lignes',
    total: 'Total période',
    byLine: 'Par ligne',
    byWo: 'Par ordre de fabrication',
    threshold: 'Seuil : ± {{pct}} %',
    tabs: {
      copper: 'Bilan cuivre',
      production: 'Analyse de production',
      materials: 'Déchet et 3 mm',
      scrap: 'Rebuts',
      stock: 'Valorisation stocks',
      sales: 'Ventes',
      receivables: 'Créances',
    },
    groupBy: 'Regrouper par',
    group: {
      day: 'Jour',
      line: 'Ligne',
      product: 'Produit',
      customer: 'Client',
      reason: 'Motif',
      stage: 'Étape',
      workOrder: 'OF',
    },
    excel: 'Excel',
    pdf: 'PDF',
    exportError: 'Export impossible. Réessayez.',
    asOfToday: 'Situation à date (pas de période).',
  },
  start: {
    title: 'Premiers pas',
    progress: '{{done}} sur {{total}} faits',
    intro:
      'Ce qu’il reste à mettre en place, dans l’ordre. Chaque ligne ouvre le bon écran ; cette carte disparaît quand tout est fait.',
    items: {
      company: {
        title: 'Identité de la société',
        hint: 'NIF, RC, adresse : imprimés sur les factures.',
      },
      steps: {
        title: 'Étapes de fabrication',
        hint: 'Tréfilage, recuit… dans l’ordre du procédé (le fil 3 mm vient de la fusion).',
      },
      line: {
        title: 'Une ligne de production',
        hint: 'La suite d’étapes que vos machines réalisent.',
      },
      product: { title: 'Un produit', hint: 'Ex. fil nu Ø 1,30 : diamètre et étapes suivies.' },
      material: {
        title: 'La matière « déchet de cuivre »',
        hint: 'Matières : déchet de cuivre, fil 3 mm, PVC…',
      },
      team: {
        title: 'Le compte de qui saisit la production',
        hint: 'Un compte « Responsable » (bureau) ou « Opérateur » (atelier) par personne.',
      },
      receive: {
        title: 'Première réception de déchet',
        hint: 'Le propriétaire, depuis son téléphone : « Réceptionner du déchet ».',
      },
      fusion: {
        title: 'Première fusion',
        hint: 'Production › Fusion (3 mm) : le déchet devient des paniers de fil 3 mm.',
      },
      production: {
        title: 'Première saisie de production',
        hint: 'Production › Saisie de production : tréfilage puis recuit, en bobines.',
      },
    },
  },
  ownerOrders: {
    useNewClient: 'Utiliser ce nouveau client',
    saleByWeight: 'Vente au poids · prix au kg',
    pickClient: 'Choisir le client',
    change: 'Changer',
    searchClient: 'Rechercher un client',
    overdueLine_one: '{{count}} facture en retard · reste {{value}}',
    overdueLine_other: '{{count}} factures en retard · reste {{value}}',
    noOverdueLine: 'Aucun impayé en retard',
    diameterMm: 'Diamètre (mm)',
    freeStock:
      '{{free}} de fil Ø {{d}} mm sont libres en stock et peuvent être réservés. Reste à produire : {{rest}}.',
    freeCovers:
      '{{free}} de fil Ø {{d}} mm sont libres en stock : la commande peut être servie depuis le stock.',
    noFree: 'Aucun fil Ø {{d}} mm libre en stock : les {{qty}} partiront en production.',
    qty: 'Quantité',
    salePrice: 'Prix de vente',
    perKg: 'DA/kg',
    lineSum: 'Ø {{d}} mm · {{qty}} × {{price}}',
    addDiameter: 'Ajouter un autre diamètre',
    removeLine: 'Retirer cette ligne',
    wantedDate: 'Livraison souhaitée',
    totalHt: 'Total HT',
    vat: 'TVA {{rate}} %',
    totalTtc: 'Total TTC',
    create: 'Créer la commande',
    title: 'Commandes clients',
    new: 'Nouvelle commande',
    newSub: 'Elle part tout de suite chez la responsable de production',
    receive: 'Réceptionner du déchet',
    none: 'Aucune commande en cours.',
    client: 'Client',
    newClient: '+ Nouveau client',
    newClientName: 'Nom du nouveau client',
    diameter: 'Diamètre',
    noProduct: 'Aucun diamètre : ajoutez un produit (Configuration › Produits).',
    quantity: 'Quantité et prix',
    qtyKg: 'Quantité (kg)',
    price: 'Prix HT (DA / kg)',
    total: 'Total HT : {{total}} DA',
    wanted: 'Souhaitée le (facultatif)',
    notes: 'Remarque (facultatif)',
    send: 'Envoyer la commande',
  },
  orders: {
    lead: 'Commandes clients au poids : à lancer en production, en cours, ou prêtes à livrer.',
    newWo: 'Ordre de fabrication',
    stat: {
      toProduce: 'À produire',
      inProduction: 'En production',
      ready: 'Prêtes à livrer',
      wire3mm: 'Fil 3 mm disponible',
      wire3mmSub: '≈ {{kg}} nécessaires',
      count_one: '{{count}} commande',
      count_other: '{{count}} commandes',
      inProdSub_one: '{{count}} commande · {{kg}} déjà produits',
      inProdSub_other: '{{count}} commandes · {{kg}} déjà produits',
    },
    tabs: {
      active: 'Actives',
      TO_PRODUCE: 'À produire',
      IN_PRODUCTION: 'En production',
      READY: 'Prêtes',
      all: 'Toutes',
    },
    diameterAll: 'Diamètre : tous',
    sortDue: 'Tri : échéance',
    sortCreated: 'Tri : création',
    col: {
      order: 'Commande',
      client: 'Client',
      diameter: 'Diamètre',
      ordered: 'Commandé',
      progress: 'Produit et réservé',
      due: 'Échéance',
      status: 'Statut',
      action: 'Action',
    },
    created: 'créée le {{date}}',
    nothing: 'Rien produit',
    coveredBy: 'Couvert par le stock ({{kg}})',
    freeIn: '{{kg}} libres en stock',
    due: {
      today: 'aujourd’hui',
      tomorrow: 'demain',
      in: 'dans {{days}} j',
      late: 'en retard de {{days}} j',
    },
    reserveStock: 'Réserver du stock',
    seeWo: 'Voir l’OF',
    prepareDn: 'Préparer le BL',
    footer: '{{count}} commandes · {{kg}} commandés',
    need: {
      title: 'Besoin par diamètre',
      intro: 'Reste à livrer des commandes actives, comparé au fil fini libre en stock',
      need: 'Besoin',
      free: 'Fil fini libre',
      colFree: 'Libre',
      toMake: 'À produire',
      covered: 'Couvert',
      aria: 'Besoin {{need}}, libre {{free}}',
      total: 'À produire : {{kg}}',
      wire: 'Fil 3 mm nécessaire ≈ {{kg}} (rendement tréfilage × recuit {{pct}} %)',
      wireNoYield: 'Fil 3 mm nécessaire ≈ {{kg}}',
      available: '{{kg}} disponibles',
      short: 'Il manque {{kg}} de 3 mm',
      none: 'Aucun besoin : toutes les commandes actives sont couvertes.',
    },
    title: 'Commandes à produire',
    intro:
      'Les commandes des clients écrites par le propriétaire. « Lancer » démarre la production de la commande ; chaque bobine terminée lui est réservée ; « Valider » quand c’est prêt.',
    open: 'En cours',
    all: 'Toutes',
    none: 'Aucune commande à produire.',
    wanted: 'souhaitée le {{date}}',
    bobbins_one: '{{count}} bobine',
    bobbins_other: '{{count}} bobines',
    start: 'Lancer la production',
    record: 'Saisir',
    validate: 'Terminer',
    nothingYet: 'Rien n’est encore produit pour cette commande',
    validateConfirm: 'La production de cette commande est terminée ?',
    deliver: 'Préparer la livraison',
    status: {
      TO_PRODUCE: 'À produire',
      IN_PRODUCTION: 'En production',
      READY: 'Prête',
      DELIVERED: 'Livrée',
    },
  },
  stock: {
    lots_one: '{{count}} lot',
    lots_other: '{{count}} lots',
    sinceDate: 'depuis le {{date}}',
    showLots: 'Voir les lots',
    hideLots: 'Masquer',
    groupCount_one: '{{groups}} produits · {{count}} lot',
    groupCount_other: '{{groups}} produits · {{count}} lots',
    lead: 'Chaque lot, dans son conteneur, au kilo près.',
    balance: {
      title: 'Bilan cuivre',
      since: 'Depuis le {{date}} · chaque kilo suivi du déchet au client',
      period: { today: 'Aujourd’hui', week: 'Semaine', month: 'Mois' },
      flow: 'Parcours du cuivre',
      received: 'reçus',
      fusionSub: 'de 3 mm · rendement {{pct}} %',
      yield: 'rendement {{pct}} %',
      check: 'écart à vérifier',
      finished: 'Stock fini',
      finishedSub: 'dont {{kg}} réservés',
      clients: 'Clients',
      delivered: 'livrés',
      where: 'Où va le cuivre reçu ({{kg}}) ?',
      whereNote: 'Sur la période : livré aux clients, perdu, et ce qui reste dans l’usine',
      inFactory: 'Reste dans l’usine',
      deliveredLeg: 'Livrés',
      lossesLeg: 'Pertes',
      recycledTitle: 'Renvoyé au four',
      notLost: 'Non perdu',
      slagTitle: 'Scories',
      loss: 'Perte',
      slagSub: '{{pct}} % du cuivre fondu',
      scrapTitle: 'Rebut déclaré',
      gapTitle: 'Écart non expliqué',
      toExplain: 'Perte · à expliquer',
      nothing: 'Rien sur la période',
    },
    tabs: { all: 'Tout', scrap: 'Déchet', wire: 'Fil 3 mm', finished: 'Fil fini' },
    statusFilter: {
      all: 'Statut : tous',
      free: 'Disponibles',
      reserved: 'Réservés',
      hold: 'Bloqués',
    },
    col: {
      container: 'Conteneur',
      containers: 'Conteneurs',
      lot: 'Lot',
      lots: 'Lots',
      product: 'Produit',
      status: 'Statut',
      in: 'Entré le',
      actions: 'Actions',
    },
    reservedFor: 'Réservée · {{code}}',
    onHold: 'Bloquée',
    more: 'Afficher {{count}} de plus',
    count: '{{shown}} sur {{total}} lots',
    panel: {
      pick: 'Choisissez un lot dans la liste pour voir son détail, le corriger ou le sortir du stock, et sa traçabilité.',
      lot: 'Lot {{code}}',
      close: 'Fermer le détail',
      gross: 'Brut',
      tare: 'Tare',
      reservedTo: 'Réservée à',
      correct: 'Corriger le poids',
      print: 'Imprimer l’étiquette',
      trace: 'Traçabilité',
      fullTree: 'Ouvrir l’arbre complet',
      received: 'Entré le {{date}}',
      basket: 'Panier',
      bobbin: 'Bobine',
      other: 'Conteneur',
      noContainer: 'Sans conteneur',
    },
    remove: 'Sortir du stock',
    removeConfirm: 'Sortir du stock',
    removeKg: 'Poids sorti (kg)',
    removeReason: 'Motif (obligatoire)',
    removeIntro:
      'Pour du cuivre qui quitte le stock hors vente (perte, échantillon, erreur de saisie…). Au plus {{kg}} libres (le réservé reste). Le motif est enregistré.',
    reason: {
      loss: 'Perte / vol',
      sample: 'Échantillon',
      error: 'Erreur de saisie',
    },
    intro:
      'Tout ce qui est dans l’usine maintenant, dans l’ordre du cycle : chaque lot, chaque panier et chaque bobine, avec son poids net.',
    search: 'N° de panier, bobine ou lot',
    empty: 'Rien ici pour le moment.',
    container: 'Panier / bobine',
    net: 'Net',
    grossTare: 'Brut − tare',
    since: 'Depuis',
    days_one: '{{count}} jour',
    days_other: '{{count}} jours',
    reserved: 'Réservé {{kg}}',
    free: 'Disponible',
    material: 'Matière',
    origin: 'Origine',
    madeHere: 'Fusion (atelier)',
    recycled: 'Récupéré (à refondre)',
    bought: 'Acheté',
    finished: 'Stock fini (bobines prêtes)',
    summaryAndThresholds: 'Synthèse par étape et diamètre, seuils d’alerte',
  },
  cycle: {
    title: 'Cycle de production',
    intro:
      'Du déchet au stock, dans l’ordre de l’atelier : ce qui attend à chaque étape maintenant, et ce qu’elle a fait sur la période. « Saisir » ouvre l’écran de l’étape.',
    record: 'Saisir',
    scrap: 'Réception du déchet',
    received: 'Reçu sur la période',
    inStock_one: '{{count}} lot',
    inStock_other: '{{count}} lots',
    containers_one: '{{count}} contenant plein',
    containers_other: '{{count}} contenants pleins',
    units_one: '{{count}} unité conditionnée',
    units_other: '{{count}} unités conditionnées',
    in: 'Entré',
    out: 'Sorti',
    losses: 'Pertes',
    slagAndGap: 'Scories + écart',
    nothing: 'Rien saisi sur la période',
    finished: 'Mise en stock (stock fini)',
    seeStock: 'Voir le stock',
    orders: 'Commandes à livrer',
    ordersSub: 'confirmées, pas encore livrées',
    seeOrders: 'Voir les commandes',
  },
  pa: {
    period: 'Période',
    preset: {
      month: 'Ce mois',
      lastMonth: 'Mois dernier',
      '7': '7 jours',
      '30': '30 jours',
      custom: 'Dates…',
    },
    empty:
      'Aucune production saisie sur cette période. Les chiffres apparaissent dès que l’atelier enregistre « Fil 3 mm » ou une étape.',
    kpi: {
      material: 'Matière entrée en production',
      materialSub: 'Déchet de cuivre, fil 3 mm acheté, PVC…',
      lost: 'Pertes totales',
      lostSub: '{{pct}} de la matière entrée',
      scrap: 'dont rebuts déclarés',
      scrapSub: 'Saisis avec un motif à l’atelier',
      gap: 'dont écart non déclaré',
      gapSub: 'Poids manquant que personne n’a déclaré',
    },
    stepsTitle: 'Pertes et rendement par étape',
    stepsIntro:
      'Ce que chaque étape a perdu, en part de ce qui y est entré : rebut déclaré, puis écart non déclaré. La barre la plus longue est l’étape à surveiller.',
    scale: 'Échelle : la barre pleine vaut {{pct}} de perte (l’étape la plus haute).',
    woIntro:
      'Les 10 OF qui ont le plus perdu sur la période, en part de la matière qu’ils ont reçue.',
    showAll: 'Tout afficher ({{count}} OF)',
    worstOnly: 'Les 10 qui ont le plus perdu',
    causesTitle: 'Pertes par cause',
    causesIntro: 'Les causes les plus lourdes d’abord : traitez le haut de la liste en priorité.',
    dailyTitle: 'Jour par jour',
    dailyIntro: 'Matière traitée chaque jour, et ce qu’elle est devenue. Survolez une colonne.',
    detailTitle: 'Détail',
    by: { wo: 'Par OF', operator: 'Par opérateur', machine: 'Par machine' },
    part: { out: 'Produit', scrap: 'Rebut déclaré', gap: 'Écart non déclaré' },
    in: 'Entrée',
    yield: 'Rendement',
    lossOf: 'perte {{pct}}',
    overflow: 'sortie > entrée',
    share: '{{pct}} des pertes',
    cumulative: 'cumul {{pct}} %',
    entries_one: '{{count}} saisie',
    entries_other: '{{count}} saisies',
    entriesCol: 'Saisies',
    materialIn: 'Matière entrée',
    lostPct: 'Perdu',
    recycled: 'Retour au déchet',
    noLoss: 'Aucune perte sur la période.',
    noWo: 'Aucun OF sur la période.',
    noMachine: 'Aucune machine renseignée dans les saisies.',
    howTo: 'Comment lire ces chiffres',
    glossary: {
      in: {
        term: 'Entrée',
        def: 'Poids pris dans le stock pour l’étape (lots de l’étape précédente, déchet, PVC…).',
      },
      out: { term: 'Produit (sortie)', def: 'Poids du lot produit, pesé à la fin de l’étape.' },
      scrap: {
        term: 'Rebut déclaré',
        def: 'Poids perdu que l’opérateur a déclaré, avec son motif.',
      },
      gap: {
        term: 'Écart non déclaré',
        def: 'Entrée − produit − rebut déclaré : du poids manquant que personne n’a expliqué. Négatif = plus de sortie que d’entrée (erreur de pesée ou de saisie).',
      },
      yield: {
        term: 'Rendement',
        def: 'Produit ÷ entrée. 98 % veut dire 2 kg perdus pour 100 kg traités.',
      },
      material: {
        term: 'Matière entrée en production',
        def: 'La matière première réellement consommée (le fil 3 mm fabriqué ici n’est compté qu’une fois, comme déchet).',
      },
    },
  },
  owner: {
    stockBlocks: 'Stock par produit',
    reservedKg: '{{kg}} réservés',
    copperStock: 'Cuivre en stock',
    seeStock: 'Voir le stock',
    kind: { scrap: 'Déchet', wire3mm: 'Fil 3 mm', wip: 'En cours', finished: 'Fil fini' },
    split: 'Répartition : {{parts}}',
    finishedSplit: 'Fil fini : {{reserved}} réservés aux commandes · {{free}} libres',
    producedToday: 'Fil fini produit',
    fusionToday: '+ {{kg}} de 3 mm sortis de fusion',
    salesToday: 'Ventes du jour',
    salesTodaySub_one: '{{value}} · {{count}} bon de livraison',
    salesTodaySub_other: '{{value}} · {{count}} bons de livraison',
    overdueSub_one: 'dont {{value}} en retard · {{count}} facture',
    overdueSub_other: 'dont {{value}} en retard · {{count}} factures',
    alertsTitle: 'Alertes',
    alertsAria: 'Alertes : {{count}}',
    alert: {
      overdue: '{{number}} en retard de {{days}} jours',
      overdueSub: '{{customer}} · reste {{value}}',
      variance: 'Écart cuivre du mois : {{pct}} %',
      varianceSub: 'Seuil ± {{threshold}} % · {{count}} OF hors seuil',
      ready: '{{code}} prête à livrer',
      readySub: '{{customer}} · {{kg}}',
      low: '{{name}} : stock bas',
      lowSub: '{{qty}} {{unit}} · seuil {{threshold}} {{unit}}',
      rod: 'Déchet de cuivre : {{days}} jours de production',
      rodSub: 'Au rythme de {{kg}} par jour',
    },
    tabs: {
      today: 'Aujourd’hui',
      orders: 'Commandes',
      stock: 'Stock',
      more: 'Argent et plus',
    },
    wipForSale: 'En-cours vendable (kg)',
    unpriced_one: '{{count}} lot de matière attend son prix d’achat',
    unpriced_other: '{{count}} lots de matière attendent leur prix d’achat',
    title: 'Direction',
    updatedAt: 'Mis à jour à {{time}}',
    offline: 'Hors ligne — dernières données de {{time}}',
    refresh: 'Actualiser',
    today: 'Production du jour',
    todayDetail: '{{units}} unités · {{cu}} de cuivre',
    month: 'Ce mois : {{m}} · {{units}} unités',
    todayKgHint: 'Fil terminé (dernière étape de fabrication)',
    packedToday: 'dont {{units}} unités conditionnées · {{m}}',
    monthKg: 'Ce mois : {{kg}}',
    packedMonth: '{{units}} unités conditionnées ({{m}})',
    last14: 'Production des 14 derniers jours (kg)',
    kgCol: 'Kg',
    chartTable: 'Voir les valeurs',
    day: 'Jour',
    metres: 'Mètres',
    units: 'Unités',
    rod: 'Déchet de cuivre',
    daysCover: '≈ {{days}} jours de production',
    noConsumption: 'Pas de consommation récente',
    variance: 'Écart cuivre du mois',
    varianceOk: 'Dans la tolérance',
    varianceAlert: 'Hors tolérance',
    flaggedWo: '{{count}} OF hors seuil',
    orders: 'Commandes en cours',
    ordersValue: '{{value}} HT',
    receivables: 'Créances clients',
    overdue: 'dont échu : {{value}}',
    noOverdue: 'Aucun impayé échu',
    alerts: 'Alertes stock',
    below: 'sous le seuil ({{threshold}} {{unit}})',
    stock: 'Stock produits finis',
    reserved: '{{count}} réservée(s)',
    lateInvoices: 'Factures échues',
    daysLate: '{{days}} j de retard',
    openOrders: 'Dernières commandes',
    activity: 'Activité récente',
    reports: 'Rapports (PDF / Excel)',
    backOffice: 'Ouvrir la gestion complète',
    running: 'Fabrication en cours',
    openFull: 'Ouvrir dans la gestion complète',
    woUnits: '{{done}} / {{target}} unités',
    now: 'en cours',
    customers: 'Clients',
    call: 'Appeler {{name}}',
    customerCredit: 'Avoir en faveur du client',
    creditLimit: 'Plafond de crédit {{limit}}',
    salesYear_one: 'Ventes {{year}} : {{value}} HT ({{count}} facture)',
    salesYear_other: 'Ventes {{year}} : {{value}} HT ({{count}} factures)',
    openInvoices: 'Factures à encaisser',
    ordersInProgress: 'Commandes en cours',
    lastPayments: 'Derniers règlements',
    approval: {
      title_one: 'À approuver',
      title_other: 'À approuver ({{count}})',
      one: 'Approbation',
      order: 'Commande',
      overdue: 'Impayés échus : {{value}}',
      overLimit: 'Encours après commande {{total}} — plafond {{limit}}',
      balance: 'Encours actuel',
      limit: 'Plafond de crédit',
      after: 'Encours avec cette commande',
      overdueLabel: 'Dont échu',
      asked: 'Demandé par {{name}} le {{date}}',
      note: 'Note pour le commercial (facultatif)',
      approve: 'Approuver',
      reject: 'Refuser',
      approveHint: 'Approuver confirme la commande immédiatement.',
      decision: 'Décision',
      decidedBy: 'Par {{name}} le {{date}}',
      status: {
        PENDING: 'En attente',
        APPROVED: 'Approuvée',
        REJECTED: 'Refusée',
        WITHDRAWN: 'Retirée (commande modifiée)',
      },
    },
    empty: 'Rien à signaler',
    install: 'Installer l’application',
    push: {
      title: 'Alertes sur ce téléphone',
      intro:
        'Recevez une notification quand une matière ou un article passe sous son seuil de stock, quand un OF dépasse le seuil d’écart cuivre et quand une facture devient échue.',
      on: 'Activées sur cet appareil',
      off: 'Désactivées sur cet appareil',
      enable: 'Activer les alertes',
      disable: 'Désactiver',
      test: 'Envoyer un test',
      testSent: 'Test envoyé : la notification arrive dans quelques secondes.',
      testNone: 'Aucun appareil n’a reçu le test. Réactivez les alertes.',
      denied:
        'Les notifications sont bloquées pour ce site : autorisez-les dans les réglages du navigateur, puis revenez ici.',
      insecure:
        'Les alertes nécessitent l’adresse sécurisée (https) du serveur installé. Elles ne fonctionnent pas sur l’adresse de test.',
      iosInstall:
        'Sur iPhone : ouvrez ce site dans Safari, touchez Partager › « Sur l’écran d’accueil », puis activez les alertes depuis l’application installée (iOS 16.4 ou plus).',
      unsupported: 'Ce navigateur ne prend pas en charge les notifications.',
      serverOff: 'Les alertes ne sont pas configurées sur le serveur (clés VAPID).',
      error: 'Impossible d’activer les alertes. Réessayez.',
    },
  },
  login: {
    subtitle: 'Connectez-vous pour accéder à la gestion de l’usine.',
    headline: 'Du déchet de cuivre au fil livré, chaque kilo est tracé.',
    points: {
      trace: 'Traçabilité de chaque lot, du déchet de cuivre jusqu’à la livraison',
      copper: 'Bilan matière cuivre en continu, écarts signalés automatiquement',
      invoice: 'Facturation conforme, numérotation sans trou, droit de timbre',
    },
  },
  auth: {
    title: 'Connexion',
    email: 'Adresse e-mail',
    password: 'Mot de passe',
    submit: 'Se connecter',
    submitting: 'Connexion…',
    logout: 'Se déconnecter',
    invalid: 'Email ou mot de passe incorrect',
    forbidden: "Votre compte n'a pas accès à cette application.",
    genericError: 'Une erreur est survenue. Réessayez.',
  },
  theme: {
    label: 'Thème',
    light: 'Clair',
    dark: 'Sombre',
    system: 'Auto',
    systemHint: 'Suit le réglage de l’appareil',
    cycle: 'Thème : {{name}}',
  },
  nav: {
    fusion: 'Fusion (3 mm)',
    entry: 'Saisie de production',
    yields: 'Rendements et pertes',
    materialsMonthly: 'Déchet et 3 mm par mois',
    stockOverview: 'Vue d’ensemble',
    users: 'Utilisateurs',
    materialLots: 'Matières et lots',
    help: 'Aide',
    dashboard: 'Tableau de bord',
    settings: 'Paramètres',
    rawMaterials: 'Matières premières',
    materialsStock: 'Stock et lots',
    salesDeliveries: 'Ventes et livraisons',
    reportsSettings: 'Rapports et paramètres',
    search: 'Rechercher un numéro',
    searchPlaceholder: 'N° de lot, panier, bobine, OF, facture…',
    notFound: 'Introuvable',
    configuration: 'Configuration',
    inventory: 'Stocks',
    production: 'Production',
    sales: 'Ventes',
    reports: 'Rapports',
    audit: "Journal d'audit",
    operator: 'Atelier',
    owner: 'Direction',
    admin: 'Administration',
    apps: 'Applications',
    main: 'Navigation principale',
    breadcrumb: 'Fil d’Ariane',
    menu: 'Menu',
    collapse: 'Réduire le menu',
    expand: 'Développer le menu',
  },
  home: {
    kpi: {
      scrap: 'Déchet reçu (ce mois)',
      scrapSub: 'En stock : {{kg}}',
      copper: 'Cuivre produit (fusion, ce mois)',
      copperSub: 'Rendement de fusion {{pct}} %',
      copperNone: 'Aucune fusion ce mois',
      stock: 'Stock disponible (fil prêt)',
      stockSub: 'Terminé aujourd’hui : {{kg}}',
      orders: 'Commandes à livrer',
    },
    cycleLink: 'Voir le cycle de production : chaque étape, son stock et ses chiffres',
    welcome: 'Bonjour, {{name}}',
    intro: 'Vue d’ensemble de l’usine : production, stocks, commandes et créances.',
    noAlerts: 'Aucune alerte de stock.',
    salesIntro:
      'D’où part la marchandise pour chaque type de vente, et le stock disponible en temps réel.',
    phase1: 'Socle technique en place. Les écrans métier arrivent dans les prochaines phases.',
  },
  common: {
    pager: {
      label: 'Pagination',
      range: '{{from}}–{{to}} sur {{total}}',
      page: 'Page {{page}} / {{pages}}',
      prev: 'Précédent',
      next: 'Suivant',
      goTo: 'Page {{page}}',
    },
    loading: 'Chargement…',
    language: 'Langue',
    comingSoon: 'Bientôt disponible',
    add: 'Ajouter',
    edit: 'Modifier',
    delete: 'Supprimer',
    save: 'Enregistrer',
    saving: 'Enregistrement…',
    saved: 'Enregistré',
    cancel: 'Annuler',
    back: 'Retour',
    search: 'Rechercher…',
    choose: '— Choisir —',
    close: 'Fermer',
    none: '— Aucun —',
    empty: 'Aucun élément',
    inactive: 'inactif',
  },
  cfg: {
    numbering: {
      title: 'Numérotation des documents',
      intro:
        'Factures, bons de livraison, avoirs, proformas et commandes. Le numéro {N} repart à 1 chaque année.',
      pattern: 'Modèle de numéro',
      digits: 'Chiffres du numéro',
      insert: 'Ajouter :',
      tokens: '{PREFIX} = préfixe du document · {YEAR} = 2026 · {YY} = 26 · {N} = numéro',
      invoice: 'Prochaine facture (exemple)',
      deliveryNote: 'Bon de livraison (exemple)',
      creditNote: 'Avoir (exemple)',
      legal:
        'S’applique aux prochains documents. Les numéros déjà attribués ne changent pas (numérotation légale sans trou).',
    },
    group: { plant: 'Usine', purchasing: 'Achats', catalog: 'Catalogue', company: 'Société' },
    lines: 'Lignes de production',
    machines: 'Machines',
    stages: 'Étapes',
    scrapReasons: 'Motifs de rebut',
    wireGauges: 'Diamètres de fil',
    containers: 'Contenants (paniers, bobines)',
    materials: 'Matières',
    suppliers: 'Fournisseurs',
    supplierCodeHint: 'FRS-0001… si vide',
    families: 'Familles de câbles',
    products: 'Fils (un par diamètre)',
    packaging: 'Conditionnements',
    skus: 'Articles (produit × conditionnement)',
    company: 'Société',
    tax: 'Taxes & numérotation',
    paymentMethods: 'Modes de paiement',
    packagingKinds: 'Types de conditionnement',
    materialTypes: 'Types de matière',
    cash: 'Espèces',
    stampBrackets: 'Droit de timbre (paiement en espèces) — tranches',
    addBracket: 'Ajouter une tranche',
    addSupply: 'Ajouter une fourniture',
    showInactive: 'Afficher inactifs',
    assets: {
      column: 'Portail',
      title: 'Photo et fiche technique',
      intro:
        'Visibles par les acheteurs sur le portail (catalogue et fiche produit). Une photo et une fiche par produit ; en choisir une nouvelle remplace l’ancienne.',
      photo: 'Photo',
      datasheet: 'Fiche technique (PDF)',
      none: 'Aucune',
      photoHint: 'JPEG, PNG ou WebP. Réduite automatiquement (1 200 px) avant l’envoi.',
      datasheetHint: 'PDF, 10 Mo maximum.',
      choosePhoto: 'Choisir une photo',
      choosePdf: 'Choisir un PDF',
      replace: 'Remplacer',
      remove: 'Retirer',
    },
    confirmDelete: 'Supprimer définitivement cet élément ?',
    inUse: 'Élément utilisé par d’autres données : désactivez-le plutôt.',
    bare: 'Nu (sans isolant)',
    customerLength: 'Longueur client',
    inStock: 'En stock',
    intro: {
      materialTypes:
        'Le rôle dit ce que fait la matière : le cuivre compte dans le bilan cuivre et entre à la première étape, l’emballage est proposé comme fourniture des conditionnements.',
      packagingKinds:
        'Catégories des conditionnements (couronne, touret, carton…). « À la coupe » : pas de longueur nominale, coupé à la longueur commandée.',
      paymentMethods:
        'Proposés sur les commandes, proformas, factures et règlements. « Espèces » applique le droit de timbre.',
      lines:
        'Chaque ligne réalise une suite ordonnée d’étapes. Les machines sont rattachées à une ligne et une étape.',
      containers:
        'Chaque panier ou bobine porte un numéro et a un poids à vide (tare). À l’atelier, on choisit le contenant et on pèse : le poids net de cuivre = brut − tare, calculé tout seul.',
      wireGauges:
        'Diamètres produits par les tréfileuses — chaque lot de fil tréfilé porte son diamètre.',
      products:
        'Un fil de cuivre nu par diamètre : saisir le diamètre et les étapes suivies. Code et désignation générés automatiquement.',
      packaging:
        '« À la coupe » : câble fini coupé à la longueur demandée par le client (pas de longueur nominale).',
      skus: 'Un article = un produit dans un conditionnement. Code généré automatiquement.',
      stages:
        'Le procédé de l’usine. Chaque étape dit ce qu’elle fait (transformation, contrôle, conditionnement), ce qu’elle consomme et si elle se vend en cours de production. Une étape utilisée ne peut que se désactiver.',
    },
    hint: {
      computed: 'vide = calculé depuis le diamètre du fil',
      lineStages: 'Cliquez dans l’ordre du procédé ; flèches pour réordonner.',
      outputDiameterMm:
        'Ex. 3,00 pour « Fil 3 mm ». Vide = le diamètre du produit (tréfilage, recuit).',
      stageKind:
        'Type et unités ne changent plus une fois de la production saisie à cette étape. Le cuivre n’est proposé qu’à la première étape d’une gamme.',
      role: 'Ne change plus une fois des matières de ce type créées.',
      boughtStage:
        'Cuivre acheté tout prêt à la place de cette étape (ex. fil 3 mm acheté) : l’étape suivante l’utilise comme les lots qu’elle produit. Vide pour une matière première.',
      cutToLength: 'Ne change plus une fois le type utilisé par un conditionnement.',
      refCode:
        'Vide = généré à partir du libellé. Ne change plus ensuite (il est enregistré sur les documents).',
      routing: 'Gamme : étapes suivies par ce produit, dans l’ordre.',
      containerCode: 'Le numéro peint ou écrit sur le contenant (P-12, B-104…).',
      tareKg: 'Poids du contenant vide, en kg (pesez-le une fois).',
      conductorClass: '1 = massive, 2 = câblée, 5 = souple',
      bare: 'Vide pour un conducteur nu',
      colors: 'Séparées par des virgules',
      copperKgPerKm: 'Masse de cuivre théorique (base du bilan cuivre)',
      phone: 'Utilisé par les boutons « Appeler » du portail',
      noCap: 'Vide = pas de plafond',
      stampBrackets:
        'Valeurs indicatives : à valider avec votre comptable selon la loi de finances en vigueur.',
    },
    f: {
      code: 'Code',
      name: 'Désignation',
      label: 'Libellé',
      labelAr: 'Libellé (arabe)',
      isCash: 'Paiement en espèces (droit de timbre)',
      cutToLength: 'À la coupe',
      containerCode: 'Numéro',
      containerKind: 'Type',
      role: 'Rôle',
      boughtStage: 'Sortie d’étape achetée',
      sortOrder: 'Ordre d’affichage',
      units: 'Unités',
      sequence: 'Ordre dans le procédé',
      stageKind: 'Type d’étape',
      inputUnit: 'Unité d’entrée',
      outputUnit: 'Unité de sortie',
      consumes: 'Consomme (en plus du lot de l’étape précédente)',
      recordsDiameter: 'Le lot produit a un diamètre de fil',
      outputDiameterMm: 'Diamètre de sortie proposé (mm)',
      sellable: 'Vendable en cours de production',
      icon: 'Dessin',
      active: 'Actif',
      notes: 'Notes',
      description: 'Description',
      line: 'Ligne',
      lineStages: 'Étapes réalisées',
      stage: 'Étape',
      diameterMm: 'Diamètre (mm)',
      materialType: 'Type',
      unit: 'Unité',
      lowStockThreshold: 'Seuil d’alerte',
      contactName: 'Contact',
      phone: 'Téléphone',
      email: 'E-mail',
      city: 'Ville',
      country: 'Pays',
      address: 'Adresse',
      conductorClass: 'Classe d’âme',
      voltageRating: 'Tension',
      insulation: 'Isolant',
      sheath: 'Gaine',
      standard: 'Norme',
      maxTemp: 'Temp. max (°C)',
      family: 'Famille',
      cores: 'Conducteurs',
      crossSection: 'Section (mm²)',
      colors: 'Couleurs',
      copperKgPerKm: 'Cuivre (kg/km)',
      compoundKgPerKm: 'Mélanges (kg/km)',
      wireDiameterMm: 'Fil (Ø mm)',
      wiresPerConductor: 'Fils par âme',
      outerDiameterMm: 'Ø extérieur (mm)',
      maxResistance: 'R max (Ω/km)',
      routing: 'Gamme de fabrication',
      kind: 'Type',
      nominalLengthM: 'Longueur nominale (m)',
      toleranceM: 'Tolérance (m)',
      tareKg: 'Tare (kg)',
      supplies: 'Fournitures consommées par unité',
      product: 'Produit',
      packaging: 'Conditionnement',
      skuThreshold: 'Seuil d’alerte (unités)',
      portalVisible: 'Visible sur le portail',
      legalName: 'Raison sociale',
      tradeName: 'Nom commercial',
      legalForm: 'Forme juridique',
      capital: 'Capital (DA)',
      wilaya: 'Wilaya',
      postalCode: 'Code postal',
      whatsappPhone: 'WhatsApp',
      website: 'Site web',
      articleImposition: 'Article d’imposition',
      bankName: 'Banque',
      invoiceFooter: 'Pied de facture',
      defaultVatRate: 'TVA par défaut (%)',
      copperVarianceThresholdPct: 'Seuil d’écart bilan cuivre (%)',
      stampDutyEnabled: 'Droit de timbre sur paiements en espèces',
      stampDutyMin: 'Timbre minimum (DA)',
      stampDutyMax: 'Timbre maximum (DA)',
      paymentTerms: 'Délai de paiement par défaut (jours)',
      daysOfCoverWindow: 'Fenêtre « jours de couverture » (jours)',
      invoicePrefix: 'Préfixe factures',
      creditNotePrefix: 'Préfixe avoirs',
      proformaPrefix: 'Préfixe proformas',
      deliveryNotePrefix: 'Préfixe bons de livraison',
      salesOrderPrefix: 'Préfixe commandes',
      workOrderPrefix: 'Préfixe OF',
    },
  },
  audit: {
    intro:
      'Qui a modifié quoi, et quand : chaque création, modification et suppression est enregistrée automatiquement, avec les valeurs avant et après.',
    searchPlaceholder: 'N° de document, code, n° de série…',
    person: 'Personne',
    allPeople: 'Toutes les personnes',
    system: 'Système',
    entity: 'Élément',
    allEntities: 'Tous les éléments',
    action: 'Action',
    allActions: 'Toutes les actions',
    from: 'Du',
    to: 'Au',
    reset: 'Effacer les filtres',
    date: 'Date',
    changes: 'Changements',
    created: 'Créé',
    deleted: 'Supprimé',
    more_one: '+{{count}} autre champ',
    more_other: '+{{count}} autres champs',
    field: 'Champ',
    before: 'Avant',
    after: 'Après',
    showAll: 'Afficher tous les champs',
    history: 'Historique de cet élément',
    historyOf: 'Historique d’un élément : {{entity}}',
    ip: 'Adresse IP',
    empty: 'Aucune entrée pour ces filtres.',
    yes: 'Oui',
    no: 'Non',
    actions: {
      INSERT: 'Création',
      UPDATE: 'Modification',
      DELETE: 'Suppression',
      LOGIN: 'Connexion',
      LOGIN_FAILED: 'Échec de connexion',
      LOGOUT: 'Déconnexion',
      REFRESH_TOKEN_REUSE: 'Session suspecte',
    },
    groups: {
      sales: 'Ventes',
      production: 'Production',
      stock: 'Stocks',
      catalog: 'Catalogue',
      plant: 'Usine',
      company: 'Société et utilisateurs',
    },
    entities: {
      Customer: 'Client',
      SalesOrder: 'Commande',
      SalesOrderLine: 'Ligne de commande',
      WipReservation: 'Réservation en-cours',
      DeliveryNote: 'Bon de livraison',
      DeliveryNoteItem: 'Lot de bon de livraison',
      Invoice: 'Facture',
      InvoiceLine: 'Ligne de facture',
      CreditNote: 'Avoir',
      CreditNoteLine: 'Ligne d’avoir',
      Proforma: 'Proforma',
      ProformaLine: 'Ligne de proforma',
      Payment: 'Règlement',
      WorkOrder: 'Ordre de fabrication',
      StageLog: 'Saisie d’étape',
      StageLogInput: 'Entrée d’étape',
      ScrapRecord: 'Rebut',
      WipLot: 'Lot en-cours',
      LotGenealogy: 'Lien de traçabilité',
      FinishedUnit: 'Unité produite',
      QualityTest: 'Contrôle qualité',
      Material: 'Matière',
      Supplier: 'Fournisseur',
      MaterialLot: 'Lot matière',
      CableFamily: 'Famille de câbles',
      CableProduct: 'Produit',
      ProductStage: 'Étape de gamme',
      PackagingType: 'Conditionnement',
      PackagingSupply: 'Fourniture de conditionnement',
      Sku: 'Article',
      WireGauge: 'Diamètre de fil',
      Stage: 'Étape',
      ProductionLine: 'Ligne de production',
      LineStage: 'Étape de ligne',
      Machine: 'Machine',
      ScrapReason: 'Motif de rebut',
      Company: 'Société',
      AppSettings: 'Paramètres',
      StampDutyBracket: 'Tranche de droit de timbre',
      User: 'Utilisateur',
    },
    fields: {
      actualStart: 'Début réel',
      actualEnd: 'Fin réelle',
      active: 'Actif',
      address: 'Adresse',
      amount: 'Montant',
      amountPaid: 'Montant réglé',
      city: 'Ville',
      code: 'Code',
      colors: 'Couleurs',
      confirmedAt: 'Confirmée le',
      contactName: 'Contact',
      copperKg: 'Cuivre (kg)',
      copperKgPerKm: 'Cuivre (kg/km)',
      cores: 'Conducteurs',
      createdBy: 'Créé par',
      creditLimit: 'Plafond de crédit',
      crossSectionMm2: 'Section (mm²)',
      customer: 'Client',
      cutLengthM: 'Longueur par pièce (m)',
      deliveredAt: 'Livré le',
      deliveryAddress: 'Adresse de livraison',
      deliveryNote: 'Bon de livraison',
      description: 'Désignation',
      diameterMm: 'Diamètre (mm)',
      driverName: 'Chauffeur',
      dueDate: 'Échéance',
      email: 'E-mail',
      endedAt: 'Fin',
      family: 'Famille',
      fullName: 'Nom complet',
      grossKg: 'Poids brut (kg)',
      invoice: 'Facture',
      issueDate: 'Date d’émission',
      kind: 'Type',
      label: 'Libellé',
      labelAr: 'Libellé (arabe)',
      legalName: 'Raison sociale',
      lengthM: 'Longueur (m)',
      line: 'Ligne',
      locale: 'Langue',
      lowStockThreshold: 'Seuil d’alerte',
      machine: 'Machine',
      material: 'Matière',
      method: 'Mode de paiement',
      name: 'Désignation',
      netKg: 'Poids net (kg)',
      notes: 'Notes',
      number: 'Numéro',
      occurredAt: 'Date',
      operator: 'Opérateur',
      order: 'Commande',
      orderDate: 'Date de commande',
      outputKg: 'Sortie (kg)',
      outputM: 'Sortie (m)',
      packagingType: 'Conditionnement',
      packedBy: 'Conditionné par',
      paidAt: 'Réglé le',
      paymentMethod: 'Mode de paiement',
      paymentStatus: 'Statut de paiement',
      paymentTermsDays: 'Délai de paiement (j)',
      phone: 'Téléphone',
      plannedEnd: 'Fin prévue',
      plannedStart: 'Début prévu',
      portalVisible: 'Visible sur le portail',
      priceUnit: 'Prix par',
      priority: 'Priorité',
      producedAt: 'Produit le',
      product: 'Produit',
      qcStatus: 'Contrôle qualité',
      qty: 'Quantité',
      qtyKg: 'Quantité (kg)',
      qtyM: 'Quantité (m)',
      qtyUnits: 'Unités',
      reason: 'Motif',
      receivedAt: 'Reçu le',
      receivedBy: 'Réceptionné par',
      receivedQty: 'Quantité reçue',
      reference: 'Référence',
      releasedAt: 'Lancé le',
      remainingQty: 'Reste',
      requestedDeliveryDate: 'Livraison souhaitée',
      reservedOrderLine: 'Réservé pour la ligne',
      result: 'Résultat',
      role: 'Rôle',
      scrapKg: 'Rebut (kg)',
      sequence: 'Ordre',
      serial: 'N° de série',
      sku: 'Article',
      stage: 'Étape',
      stampDuty: 'Droit de timbre',
      startedAt: 'Début',
      status: 'Statut',
      stockStatus: 'Statut de stock',
      supplier: 'Fournisseur',
      targetLengthM: 'Longueur visée (m)',
      targetUnits: 'Unités visées',
      testedAt: 'Testé le',
      tester: 'Contrôleur',
      totalHt: 'Total HT',
      totalTtc: 'Total TTC',
      totalVat: 'TVA',
      type: 'Type',
      unit: 'Unité',
      unitCost: 'Coût unitaire',
      unitPrice: 'Prix unitaire HT',
      validUntil: 'Valable jusqu’au',
      validatedAt: 'Validé le',
      validatedBy: 'Validé par',
      vatRate: 'Taux de TVA',
      vehiclePlate: 'Véhicule',
      voltageTestPassed: 'Essai de tension réussi',
      wilaya: 'Wilaya',
      workOrder: 'OF',
    },
  },
  users: {
    title: 'Utilisateurs',
    intro: 'Comptes du personnel et des acheteurs du portail.',
    new: 'Nouvel utilisateur',
    fullName: 'Nom complet',
    role: 'Rôle',
    customer: 'Client (acheteur)',
    active: 'Actif',
    disabled: 'Désactivé',
    lastLogin: 'Dernière connexion',
    resetPassword: 'Réinitialiser le mot de passe',
    newPassword: 'Nouveau mot de passe',
    passwordHint: '10 caractères minimum, dont une lettre et un chiffre',
    resetEffect: 'Toutes les sessions de cet utilisateur seront fermées.',
  },
  count: {
    title: 'Inventaires',
    intro:
      'Comptage physique du stock : lancez un inventaire, les opérateurs scannent et comptent sur la tablette (« Inventaire »), puis validez les écarts.',
    new: 'Nouvel inventaire',
    none: 'Aucun inventaire.',
    code: 'N°',
    started: 'Lancé le',
    startedBy: 'Lancé par',
    scope: 'Périmètre',
    lines: 'Articles comptés',
    status: { OPEN: 'En cours', POSTED: 'Validé', CANCELLED: 'Annulé' },
    kind: { MATERIAL_LOT: 'Matières', WIP_LOT: 'En-cours', FINISHED_UNIT: 'Produits finis' },
    nMaterials_one: '{{count}} matière',
    nMaterials_other: '{{count}} matières',
    nProducts_one: '{{count}} produit',
    nProducts_other: '{{count}} produits',
    newHint:
      'Tout ce qui est en stock dans le périmètre devra être scanné : à la validation, ce qui n’a pas été compté est considéré comme manquant (sauf ce qui est entré après le lancement).',
    whatToCount: 'Que compte-t-on ?',
    onlyMaterials: 'Seulement ces matières',
    onlyProducts: 'Seulement ces produits (en-cours et produits finis)',
    all: '(toutes si rien n’est coché)',
    selected_one: '({{count}} cochée)',
    selected_other: '({{count}} cochées)',
    notes: 'Remarque',
    start: 'Lancer l’inventaire',
    startedOn: 'Lancé le {{date}} par {{name}}',
    postedOn: 'validé le {{date}} par {{name}}',
    cancel: 'Annuler l’inventaire',
    post: 'Valider l’inventaire',
    postTitle: 'Valider l’inventaire',
    postIntro: 'Les écarts seront passés en stock comme ajustements d’inventaire :',
    sumAdjusted_one: '{{count}} article corrigé',
    sumAdjusted_other: '{{count}} articles corrigés',
    sumMissing_one: '{{count}} article non compté, sorti du stock comme manquant',
    sumMissing_other: '{{count}} articles non comptés, sortis du stock comme manquants',
    sumFound_one: '{{count}} unité retrouvée, remise en stock',
    sumFound_other: '{{count}} unités retrouvées, remises en stock',
    sumValue: 'Écart de valeur des matières : {{value}}',
    reservedWarn_one:
      '{{count}} article réservé pour une commande est concerné : la commande devra être réservée à nouveau.',
    reservedWarn_other:
      '{{count}} articles réservés pour des commandes sont concernés : les commandes devront être réservées à nouveau.',
    postIrreversible:
      'Irréversible : une erreur se corrige par un nouvel inventaire ou un ajustement.',
    postConfirm: 'Valider et passer les écarts',
    cancelTitle: 'Annuler l’inventaire',
    cancelIntro: 'Les comptages sont conservés pour mémoire ; aucun stock n’est modifié.',
    cancelConfirm: 'Annuler l’inventaire',
    openHint:
      'Écarts calculés en direct par rapport au stock au moment de chaque comptage : la production peut continuer pendant l’inventaire. Un article non compté sera sorti comme manquant à la validation.',
    counted: 'Comptés',
    missingIfPosted: 'Non comptés (manquants)',
    anomalies_one: '{{count}} anomalie',
    anomalies_other: '{{count}} anomalies',
    valueDiff: 'Écart valeur matières',
    wipDiff: 'En-cours : {{kg}}',
    differences: 'Écarts',
    onlyDiffs: 'Écarts seulement',
    everything: 'Tout',
    noDiffs: 'Aucun écart.',
    item: 'Lot / n° de série',
    article: 'Article',
    system: 'Stock système',
    countedQty: 'Compté',
    notCounted: 'non compté',
    seen: 'vu',
    delta: 'Écart',
    value: 'Valeur',
    result: 'Résultat',
    countedBy: 'Compté par',
    posted: 'Passé en stock',
    cancelledLines: 'Comptages (inventaire annulé)',
    outcome: {
      MATCH: 'Conforme',
      ADJUSTED: 'Écart',
      MISSING: 'Manquant',
      FOUND: 'Retrouvé',
      ANOMALY: 'Anomalie',
    },
    capped: 'Plafonné : le stock a baissé depuis le comptage',
    reservedFor: 'Réservé : {{order}}',
    anomalyHint:
      'Le système le donne sorti du stock (livré, rebuté…) : à vérifier, rien n’est passé.',
  },
  opc: {
    title: 'Inventaire',
    stepPick: 'Inventaire',
    stepScan: 'Comptage',
    none: 'Aucun inventaire en cours. Le responsable le lance depuis le bureau (Stocks › Inventaires).',
    startedBy: 'Lancé le {{date}} par {{name}}',
    linesSoFar_one: '{{count}} article compté',
    linesSoFar_other: '{{count}} articles comptés',
    scan: 'Scanner / saisir un code (lot ou n° de série)',
    scanHint:
      'Scannez l’étiquette. Une couronne ou un touret est compté par son scan ; pour un lot, saisissez la quantité trouvée.',
    outOfScope: '{{code}} ({{label}}) ne fait pas partie de cet inventaire',
    unitCounted: '{{code}} compté',
    lotCounted: '{{code}} : {{qty}} enregistré',
    countedSoFar_one: '{{count}} article compté',
    countedSoFar_other: '{{count}} articles comptés',
    nothingYet: 'Rien de compté pour l’instant.',
    remove: 'Retirer {{code}}',
    alreadyCounted: 'Déjà compté : {{qty}}. La nouvelle saisie remplace l’ancienne.',
    qty: 'Quantité trouvée',
    qtyKg: 'Poids trouvé',
    wholePieces: 'Nombre de pièces entières',
    lengthOptional: 'Longueur (facultatif)',
    lengthHint: 'Sinon déduite du poids.',
    note: 'Remarque',
    save: 'Enregistrer le comptage',
    qtyRequired: 'Saisissez la quantité trouvée (0 si le lot est vide).',
    closed: 'L’inventaire {{code}} est clôturé.',
  },
  inv: {
    nav: { stock: 'État des stocks' },
    materials: 'Matières premières et fournitures',
    wip: 'En-cours (fil 3 mm, tréfilé, recuit…)',
    wipIntro: 'Lots produits par l’atelier et pas encore consommés, par étape et diamètre de fil.',
    noWip: 'Aucun en-cours en stock.',
    byWeight: 'Stock fini au poids',
    byWeightIntro:
      'Production des OF « pour le stock » terminés (ex. fil recuit), par produit et diamètre. Se vend au kg ; une étape suivante peut encore l’utiliser.',
    noByWeight: 'Aucun stock fini au poids.',
    container: 'Contenant',
    fusion: {
      title: 'Fusion',
      summary: 'Déchet fondu {{melted}} kg → cuivre obtenu {{obtained}} kg · scories {{slag}} kg.',
      obtained: 'Bon cuivre obtenu (kg)',
      used: 'Ce lot a déjà été utilisé : corrigez par un ajustement d’inventaire ci-dessous.',
    },
    product: 'Produit',
    from: 'Étape',
    stage: 'Étape',
    diameter: 'Diamètre',
    reserved: 'Réservé',
    onHold: 'Bloqué',
    copper: 'Cuivre',
    madeFor: 'Fait pour',
    threshold: 'Seuil bas',
    toPrice: 'prix à compléter',
    workOrder: 'OF',
    producedAt: 'Production',
    status: 'État',
    low: 'Stock bas',
    onHand: 'En stock',
    openLots: 'Lots ouverts',
    value: 'Valeur',
    lotsFifo: 'lots (ordre FIFO)',
    includeDepleted: 'Inclure les lots épuisés',
    lot: 'Lot',
    receivedAt: 'Réception',
    received: 'Reçu',
    remaining: 'Reste',
    receivedBy: 'Réceptionné par',
    movements: 'Mouvements',
    date: 'Date',
    type: 'Type',
    qty: 'Quantité',
    ref: 'Référence',
    by: 'Par',
    adjust: 'Ajustement d’inventaire',
    delta: 'Écart',
    reason: 'Motif',
  },
  op: {
    backOffice: 'Retour au bureau',
    pad: {
      label: 'Clavier numérique',
      comma: 'Virgule',
      back: 'Effacer le dernier chiffre',
      clear: 'Tout effacer',
      next: 'Champ suivant',
      step: 'Étape {{step}} sur {{total}}',
      continue: 'Suivant',
    },
    find: {
      label: 'Scanner ou taper un lot ou un conteneur',
      placeholder: 'Scanner ou taper : lot, panier, bobine',
      notFound: '{{code}} : introuvable',
      empty: 'Vide',
    },
    soon: 'Bientôt',
    hello: 'Bonjour, {{name}}',
    whatNow: 'Que faites-vous maintenant ?',
    shift: {
      MORNING: 'Équipe du matin',
      AFTERNOON: 'Équipe de l’après-midi',
      NIGHT: 'Équipe de nuit',
    },
    waiting: {
      lowMaterials_one: '{{count}} matière sous le seuil',
      lowMaterials_other: '{{count}} matières sous le seuil',
      openWos_one: '{{count}} OF en cours',
      openWos_other: '{{count}} OF en cours',
      noWo: 'Aucun OF lancé',
      pendingUnits_one: '{{count}} unité à contrôler',
      pendingUnits_other: '{{count}} unités à contrôler',
      heldLots_one: '{{count}} lot bloqué',
      heldLots_other: '{{count}} lots bloqués',
      openCounts_one: 'Inventaire en cours',
      openCounts_other: '{{count}} inventaires en cours',
    },
    steps: {
      material: 'Matière',
      quantity: 'Quantité',
      label: 'Étiquette',
      workOrder: 'Ordre de fabrication',
      stage: 'Étape',
      diameter: 'Produit',
      entry: 'Saisie',
      packing: 'Conditionnement',
    },
    toRecord: 'À enregistrer',
    outputWeight: 'Poids produit',
    inputsTotal: 'Entrées',
    lotsUsed: 'Lots utilisés',
    output: 'Production',
    fifo: 'Premier entré (FIFO)',
    gauge: {
      output: 'Produit',
      scrap: 'Rebut',
      gap: 'Écart',
      over: 'Excédent',
      offcut: 'Chute',
      left: 'Reste',
    },
    tilesDesc: {
      wire3mm: 'Déchet de cuivre fondu → fil 3 mm',
      receive: 'Déchet de cuivre, PVC, emballages',
      produce: 'Tréfilage, recuit… à partir du fil 3 mm',
      pack: 'Couronnes, tourets, coupe',
      qc: 'Essais et validation des unités',
      count: 'Comptage du stock par scan',
    },
    tiles: {
      wire3mm: 'Fusion',
      receive: 'Réception matière',
      produce: 'Production',
      pack: 'Conditionnement',
      qc: 'Contrôle qualité',
      count: 'Inventaire',
    },
    stocks: {
      raw: 'Déchet de cuivre en stock',
      wire3mm: 'Fil 3 mm en stock',
    },
    wire3mm: {
      steps: { baskets: 'Paniers', weigh: 'Pesée', balance: 'Bilan', done: 'Terminé' },
      pickTitle: 'Quels paniers sortent du four ?',
      noBasket: 'Sans panier',
      noBasketHint: 'Un seul poids : le cuivre obtenu',
      weighTitle: 'Pesée des paniers',
      weighSub: 'Tapez le poids brut de chaque panier ; un panier laissé vide n’est pas enregistré',
      weighOne: 'Pesée du cuivre obtenu',
      weighOneSub: 'Tapez le poids lu sur la balance',
      basket: 'Panier {{code}}',
      tareNet: 'tare {{tare}} kg · net {{net}}',
      weighed: 'Paniers pesés',
      grossTare: '{{gross}} − tare {{tare}}',
      producedTotal: 'Fil 3 mm produit',
      balanceTitle: 'Bilan de la fusion',
      balanceSub: 'Tapez les poids lus sur la balance',
      usedShort: 'Déchet fondu',
      usedSub: 'pesé avant chargement (vide = cuivre obtenu)',
      slagSub: 'crasses retirées du four',
      recoveredShort: 'Déchet récupéré',
      recoveredSub: 'retourne au stock déchet',
      legend3mm: '3 mm',
      legendRecovered: 'Récupéré',
      legendSlag: 'Scories',
      gapChip: 'Écart {{kg}} kg · {{pct}} %',
      overChip: '{{kg}} kg de trop : vérifiez les poids',
      barAria:
        '{{used}} kg fondus : fil 3 mm {{out}} kg, récupéré {{rec}} kg, scories {{slag}} kg, écart {{gap}} kg',
      yieldLine: 'Rendement de fusion {{pct}} %',
      stockLine: 'Déchet en stock : {{before}} → {{after}} kg',
      validate: 'Valider la fusion',
      finish: 'Valider',
      toBalance: 'Bilan',
      baskets: 'Paniers remplis',
      basketsHint:
        'Facultatif : touchez chaque panier rempli à la sortie du four (chaque panier pesé devient un lot de fil 3 mm), ou continuez sans panier avec un seul poids. Le bilan (déchet fondu, scories, récupéré) est facultatif aussi : « Valider » dès la pesée.',
      intro:
        'Pesez ce qui entre dans le four, puis le cuivre obtenu et les scories. Le déchet sort du stock cuivre, le cuivre obtenu entre dans le stock 3 mm.',
      produced: 'Cuivre obtenu',
      used: 'Déchet de cuivre fondu',
      usedHint: 'Le poids de déchet mis au four (vide = même poids que le cuivre obtenu).',
      recovered: 'Déchet récupéré (retour au stock)',
      recoveredHint:
        'Coulures, chutes, ratés de fusion : ce poids revient au stock de déchet pour être refondu (ce n’est pas une perte).',
      slag: 'Scories',
      slagHint: 'Si vous les pesez : elles comptent comme perte déclarée, pas comme écart.',
      yield: 'Rendement de fusion',
      loss: 'Écart non déclaré',
      after: 'Après enregistrement',
      material: 'Quel fil 3 mm ?',
      notEnough: 'Pas assez de déchet de cuivre en stock : {{kg}} kg disponibles.',
      noMaterial:
        'Aucune matière « fil 3 mm » n’existe. Demandez au responsable de la créer (Configuration › Matières).',
      confirm: 'Enregistrer',
      done: 'Fusion enregistrée',
      another: 'Saisir un autre',
    },
    receive: {
      step1: 'Quelle matière réceptionnez-vous ?',
      step2: 'Réception',
      inStock: 'En stock',
      qty: 'Quantité reçue',
      supplier: 'Fournisseur',
      certRef: 'N° certificat',
      supplierLot: 'Lot fournisseur',
      unitCost: 'Prix unitaire HT',
      unitCostHint: 'Par kg, hors taxes. Visible par vous seul ; vide = à compléter plus tard.',
      value: 'Valeur HT',
      costHint: 'Prérempli avec le dernier prix d’achat.',
      confirm: 'Valider la réception',
      done: 'Lot créé',
      copies: 'Étiquettes :',
      print: 'Imprimer l’étiquette',
      another: 'Nouvelle réception',
      finish: 'Terminé',
    },
  },
  opp: {
    sub: {
      reservedTo: 'Réservée à',
      oneByOne: 'Choisir les paniers / bobines un par un',
      baskets_one: '{{count}} panier',
      baskets_other: '{{count}} paniers',
      bobbins_one: '{{count}} bobine',
      bobbins_other: '{{count}} bobines',
      containers_one: '{{count}} conteneur',
      containers_other: '{{count}} conteneurs',
      loose_one: '{{count}} lot sans conteneur',
      loose_other: '{{count}} lots sans conteneur',
      freeKg: '{{kg}} kg libres',
      stage: 'Étape',
      inputs: 'Entrée',
      container: 'Bobine',
      weigh: 'Pesée',
      scrap: 'Rebut',
      inputsHint:
        'Touchez « Utiliser » pour choisir le lot d’entrée (ou scannez son panier). Sans choix, les lots les plus anciens sont pris.',
      autoInputs: 'Les plus anciens (automatique)',
      output: 'Bobine de sortie',
      noContainer: 'Sans conteneur',
      tareOf: 'Tare {{code}}',
      net: 'Poids net',
      over: 'Plus lourd que l’entrée ({{kg}} kg) : vérifiez la balance',
      left: 'Entrée : reste {{kg}} kg à sortir ou à déclarer en rebut',
      validateWeigh: 'Valider la pesée',
      scrapHint: 'Laissez vide s’il n’y a pas de rebut',
    },
    freeBobbin: 'Bobine sans numéro',
    freeBobbinHint: 'Poids vide saisi',
    freeTare: 'Poids vide de la bobine',
    pickWo: 'Choisissez l’ordre de fabrication',
    nextStage: 'Étape suivante',
    stageDone: 'Faite',
    qcPick: 'Sélectionnez les unités à contrôler',
    qcUnitsWord_one: 'unité',
    qcUnitsWord_other: 'unités',
    noWo: 'Aucun OF lancé. Demandez au responsable de lancer un OF.',
    pickStage: 'Quelle étape réalisez-vous ?',
    next: 'suivante',
    machine: 'Machine',
    scan: 'Scanner / saisir un code de lot',
    scanUnknown: 'Ce lot ne peut pas être utilisé à cette étape',
    wipInputs: 'Lots en-cours (étape précédente)',
    materialInputs: 'Matières',
    container: 'Peser dans un contenant',
    containerHint:
      'Choisissez le panier ou la bobine (ou scannez son numéro), puis tapez le poids brut : le net (brut − tare) se calcule tout seul et l’entrée est prise dans le stock, les plus anciens d’abord.',
    containerReuse: 'Contient l’entrée {{code}} : vidée puis réutilisée',
    containerFull: 'Plein : {{code}}',
    tare: 'Tare {{kg}} kg',
    gross: 'Poids brut — {{code}}',
    net: 'Poids net (tare {{kg}} kg déduite)',
    submitNext: 'Enregistrer et peser le suivant',
    scrapGoesTo: 'Que devient ce rebut ?',
    recycle: 'Retour au déchet (à refondre)',
    lost: 'Perdu',
    continueTo: 'Continuer : {{stage}}',
    pickStep: 'Quelle étape faites-vous ?',
    pickDiameter: 'Que fabriquez-vous ?',
    plannedOf: 'Saisir pour un OF planifié',
    workshop: 'Atelier',
    readyContainers_one: '{{kg}} kg prêts dans {{count}} contenant ({{step}})',
    readyContainers_other: '{{kg}} kg prêts dans {{count}} contenants ({{step}})',
    ready: '{{kg}} kg prêts ({{step}})',
    rawMaterial: 'matière',
    nothingWaiting: 'Rien en attente pour ce produit',
    noProductForStep: 'Aucun produit ne passe par cette étape (Configuration › Produits).',
    savedNext: 'Lot {{code}} enregistré. Choisissez le contenant suivant.',
    boughtInputs: 'Fil en stock',
    bought: 'Stock',
    madeFor: 'fait pour',
    otherWo: 'autre OF',
    use: 'Utiliser',
    used: 'Utilisé',
    leftover: {
      title: '{{kg}} kg pris en trop ?',
      body: 'Vous avez pris {{taken}} kg en entrée, mais la pesée et le rebut n’en expliquent que {{out}} kg.',
      keep: 'Laisser {{kg}} kg en stock (dans leurs paniers)',
      scrap: 'C’est une perte : déclarer {{kg}} kg en rebut',
    },
    unuse: 'Retirer',
    qtyKg: 'Quantité (kg)',
    outputKg: 'Poids produit (kg)',
    outputM: 'Longueur produite (m)',
    diameter: 'Diamètre du fil',
    scrapKg: 'Rebut (kg)',
    scrapReason: 'Motif du rebut',
    notes: 'Remarque',
    submit: 'Enregistrer l’étape',
    testingInfo:
      'Étape d’essais : enregistre le passage au banc. Les mesures se saisissent dans « Contrôle qualité ».',
    doneTitle: 'Étape enregistrée',
    newLot: 'Nouveau lot en-cours',
    printLabel: 'Imprimer l’étiquette du lot',
    another: 'Nouvelle saisie',
    noWip: 'Aucun lot disponible à l’étape précédente.',
    packTitle: 'Conditionnement',
    pickSource: 'Lot à conditionner',
    packaging: 'Conditionnement',
    units: 'Unités',
    addUnit: 'Ajouter une unité',
    pieceLength: 'Longueur (m)',
    pieceWeight: 'Poids net (kg)',
    packBy: 'Conditionner',
    byWeight: 'Par poids (pesée)',
    byLength: 'Par longueur',
    totalKg: 'Total : {{m}} kg sur {{avail}} kg disponibles',
    offcut: 'Chute restante (m) à rebuter',
    offcutKg: 'Chute restante (kg) à rebuter',
    totalM: 'Total : {{m}} m sur {{avail}} m disponibles',
    packSubmit: 'Créer les unités',
    packDone: 'Unités créées',
    printUnits: 'Imprimer les étiquettes',
    qcTitle: 'Contrôle qualité',
    qcUnits: 'Unités finies',
    qcWip: 'Lots en-cours',
    wipAvailable: 'Disponibles',
    wipHeld: 'Bloqués',
    wipNone: 'Aucun lot.',
    blocked: 'Bloqué',
    pickLot: 'Choisissez le lot à contrôler (scan ou liste).',
    lastTest: 'Dernier contrôle : {{result}} le {{date}}',
    untested: 'Jamais contrôlé',
    wireDiameter: 'Ø du fil (mm)',
    qcNotes: 'Remarque (motif si non conforme)',
    wipFailHint:
      'Non conforme bloque le lot : il ne peut plus être consommé ni livré, seulement rebuté. Un contrôle conforme le débloque.',
    wipBlocked: '{{code}} : non conforme — lot bloqué (consommation et livraison impossibles)',
    wipReleased: '{{code}} : conforme — lot disponible',
    qcPending: 'Unités en attente de contrôle',
    qcNone: 'Aucune unité en attente.',
    qcMore:
      '{{shown}} unités affichées sur {{total}} (les plus anciennes) : contrôlez-les, la suite apparaîtra.',
    selectAll: 'Tout sélectionner',
    resistance: 'Résistance âme (Ω/km)',
    maxR: 'max {{max}}',
    insulation: 'Résistance d’isolement (MΩ·km)',
    voltage: 'Essai de tension (kV)',
    voltageOk: 'Tension tenue',
    diameterOut: 'Ø extérieur (mm)',
    pass: 'CONFORME',
    fail: 'NON CONFORME',
    selected: '{{count}} sélectionnée(s)',
    suggestFail: 'Résistance au-dessus du maximum : non conforme conseillé',
  },
  setup: {
    title: 'Première installation',
    intro:
      'Créez le compte du propriétaire. Il pourra ensuite créer les autres utilisateurs et configurer l’usine.',
    submit: 'Créer le compte propriétaire',
  },
  help: {
    back: 'Retour',
    scope: 'Rubriques affichées',
    all: 'Tout le guide',
    mine: 'Pour mon rôle',
    contents: 'Sommaire',
  },
  flow: {
    stockTitle: 'Stock par étape de production',
    saleTitle: 'Vendre — d’où part la marchandise',
    live: 'Mis à jour en continu',
    raw: 'Déchet de cuivre',
    rawIn: 'Déchet : {{kg}} kg',
    bought: 'Fil en stock (fabriqué ou acheté)',
    byWeight: 'Au poids (OF pour le stock terminés)',
    byWeightIn: 'Au poids : {{kg}} kg',
    finished: 'Stock fini',
    customer: 'Client',
    lots_one: '{{count}} lot',
    lots_other: '{{count}} lots',
    units_one: '{{count}} unité',
    units_other: '{{count}} unités',
    running_one: '{{count}} OF en cours',
    running_other: '{{count}} OF en cours',
    empty: 'Aucun stock',
    low: 'Bas',
    sellHere: 'vente',
    available: 'Disponible à la vente',
    length: 'Longueur',
    reserved: 'Réservé',
    reservedPending: 'Réservées / en attente CQ',
    byDiameter: 'Par diamètre :',
    clickHint: 'Cliquez sur une étape pour voir le détail.',
    hint: {
      PACKAGED: 'Couronnes et tourets du stock fini (contrôle qualité conforme, non réservés).',
      CUT_LENGTH: 'Câble fini coupé à la longueur demandée par le client, depuis le stock fini.',
      IN_PROCESS:
        'Produit prélevé en cours de fabrication : fil tréfilé par diamètre, conducteurs, conducteurs isolés…',
    },
  },
} as const;

type Widen<T> = { [K in keyof T]: T[K] extends string ? string : Widen<T[K]> };
export type Messages = Widen<typeof fr>;
